/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';
import FilterModule from 'app/mixins/FilterModule.js';
import SortModule from 'app/mixins/SortModule.js';


export const subaccounts = (state = defaultState.subaccounts, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        subaccounts = [];

    switch (action.type) {
        case constants.UTILITIES_FILTER_STORE:
            if (action.store === 'subaccounts') {
                nextState.filter = {
                    key: action.filter,
                    value: action.value,
                    exact: action.exact
                };
                nextState.filteredList = FilterModule(nextState.list, action.filter, action.value, action.exact);
            }
            break;

        case constants.UTILITIES_SORT_STORE:
            if (action.store === 'subaccounts') {
                nextState.sort = {
                    key: action.key,
                    direction: action.direction
                };
                nextState.list = SortModule(nextState.list, action.key, action.direction);
                if (nextState.filteredList.length > 0) {
                    nextState.filteredList = SortModule(nextState.filteredList, action.key, action.direction);
                }
            }
            break;

		case constants.UTILITIES_CLEAR_FILTER:
			if (action.store === 'subaccounts') {
                nextState.filter = {};
				nextState.filteredList = [];
			}
			break;

        case constants.SUBACCOUNT_LIST:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.list = action.payload;
            } else {
                // reset the list since we may be grabbing a different type
                // of subaccount (agent vs. client)
                nextState.list = [];
            }
            break;

        case constants.SUBACCOUNT_SHOW:
        case constants.SUBACCOUNT_UPDATE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState.list[i] = action.payload;
                        break;
                    }
                }
            }
            break;

        case constants.SUBACCOUNT_DELETE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].id, 10) !== parseInt(action.payload.id, 10)) {
                        subaccounts.push(nextState.list[i]);
                    }
                }
                nextState.list = subaccounts;
            }
            break;

        case constants.SUBACCOUNT_CREATE:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.list.push(action.payload);
            }
            break;

        default:
            break;

    }

    return nextState;
};
